<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseNode from './BaseNode.vue';
import AutomationPreviewAccordion from '../AutomationPreviewAccordion.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();

const automationTypeLabel = computed(() => {
  const type = props.data.automation?.type;
  return type ? t(`SOPS.AUTOMATION_TYPES.${type.toUpperCase()}`) : '';
});

const mode = computed(() => props.data.mode || 'manual');
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    icon="i-lucide-zap"
    :type-label="t('SOPS.NODES.AUTOMATION')"
    :node-label="data.label"
    accent-class="bg-n-ruby-9/15 text-n-ruby-11"
  >
    <div class="border-t border-n-weak p-3">
      <template v-if="data.automation">
        <AutomationPreviewAccordion
          :id="data.automation.id"
          :type="data.automation.type"
          :name="`${automationTypeLabel} - ${data.automation.name}`"
        />
        <p
          class="mb-0 mt-1 flex items-center gap-1 text-xs"
          :class="mode === 'auto_pilot' ? 'text-n-teal-11' : 'text-n-amber-11'"
        >
          <span
            class="size-3 shrink-0"
            :class="mode === 'auto_pilot' ? 'i-lucide-rocket' : 'i-lucide-hand'"
          />
          {{ t(`SOPS.BUILDER.PANEL.MODE_ON_${mode.toUpperCase()}`) }}
        </p>
      </template>
      <p v-else class="mb-0 flex items-center gap-1 text-xs text-n-amber-11">
        <span class="i-lucide-triangle-alert size-3" />
        {{ t('SOPS.BUILDER.PANEL.NOT_CONFIGURED') }}
      </p>
    </div>
  </BaseNode>
</template>
